import React from "react";

// Material UI
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

const EmailLogsHeader = () => {
  const headCells = [
    { id: "Email", numeric: false, label: "Email" },
    { id: "Subject", numeric: false, label: "Subject" },
    { id: "Sent Date", numeric: false, label: " Sent Date / Time" },
    { id: "Email Status", numeric: false, label: " Email Status" },
    { id: "Action", numeric: false, label: " Action" },
  ];

  return (
    <TableHead>
      <TableRow className="header">
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            className="headerText"
            align="center"
            padding="normal"
            size="medium"
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default EmailLogsHeader;
